import { FC } from "react";

import { Grid } from "@mui/material";

type BuyerInformationSectionLayoutProps = {
  slots: {
    email: React.ReactNode;
    publicDonation?: React.ReactNode;
    addressAndName?: React.ReactNode;
    notificationPhone?: React.ReactNode;
    organizationDonation?: React.ReactNode;
    auctionAnonymousBid?: React.ReactNode;
  };
};

export const BuyerInformationSectionLayout: FC<BuyerInformationSectionLayoutProps> = ({ slots }) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        {slots.email}
      </Grid>
      {slots.publicDonation && (
        <Grid item xs={12} sx={{ marginBlock: 1 }}>
          {slots.publicDonation}
        </Grid>
      )}
      {slots.addressAndName && (
        <Grid item xs={12}>
          {slots.addressAndName}
        </Grid>
      )}
      {slots.notificationPhone && (
        <Grid item xs={12} sx={{ marginBlock: 1 }}>
          {slots.notificationPhone}
        </Grid>
      )}
      {slots.organizationDonation && (
        <Grid item xs={12} sx={{ marginBlock: 1 }}>
          {slots.organizationDonation}
        </Grid>
      )}
      {slots.auctionAnonymousBid && (
        <Grid item xs={12} sx={{ marginBlock: 1 }}>
          {slots.auctionAnonymousBid}
        </Grid>
      )}
    </Grid>
  );
};
